module.exports = __webpack_public_path__ + "img/7ce20b5ca04d0e3061d326ca597133f7.png";